'use es6';

import { PureComponent, Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
let popoverId = 0;
export default class Popovers extends PureComponent {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error(error);
    console.info(errorInfo.componentStack);
  }
  render() {
    const {
      editor
    } = this.props;
    if (this.state.hasError) {
      return null;
    }
    return /*#__PURE__*/_jsx(Fragment, {
      children: editor.popovers && Object.keys(editor.popovers).map(popover => editor.popovers[popover].renderPopover({
        key: `mce-hubspot-popover-${++popoverId}`
      }))
    });
  }
}